// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"LoaderContent_loaderWrapper__DDgAf"};